<template>
  <div
    :id="id"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="pic_of_resume_modal"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      :class="'modal-' + size + ' ' + position + ' ' + modalClass"
      role="document"
    >
      <div class="modal-content">
        <!-- aタグで閉じるボタンを作らないとform内にmodalが存在する際にenterを押すと閉じる動作が作用する -->
        <a
          v-if="showClose"
          class="close position-absolute right-0 pt-5 pr-5"
          data-dismiss="modal"
          aria-label="Close"
          @click="onClose"
        >
          <span aria-hidden="true">
            <i class="material-icons md-dark mb-36">clear</i>
          </span>
        </a>
        <div
          v-if="title"
          class="modal-header"
          :class="modalHeaderClass"
        >
          <h5
            :class="headerTitleClass"
          >
            <span>{{ title }}</span>
            <span
              v-if="provision != ''"
              class="font-small pc-inline text-dark-gray"
              :class="provisionClass"
            >
              {{ provision }}
            </span>
          </h5>
        </div>
        <div
          class="modal-body"
          :class="modalBodyClass"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    provision: {
      type: String,
      default: ""
    },
    provisionClass: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "lg"
    },
    modalClass: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "modal-dialog-centered"
    },
    headerTitleClass: {
      type: String,
      default: "modal-title"
    },
    showClose: {
      type: Boolean,
      default: true
    },
    modalBodyClass: {
      type: String,
      default: ""
    },
    modalHeaderClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-sm {
  max-width: 460px;
  .modal-body {
    padding: 45px 55px 28px;
  }
}
.modal-md {
  max-width: 520px;
}
.modal-lg {
  max-width: 800px;
}
.modal-xl {
  max-width: 1000px;
}
.modal-md, .modal-lg {
  .modal-header {
    padding: 42px 50px 35px;
    border-bottom: none;
    .modal-title {
      width: 100%;
      padding-bottom: 5px;
      font-size: 14px;
      font-weight: bold;
      border-bottom: 1px solid #DBDEE1;
    }
  }
  .modal-body {
    padding: 0 50px 56px;
    &.narrow {
      padding: 0 70px 56px;
    }
    &.shallow {
      padding: 0 50px 39px;
    }
  }
}
.center-title {
  margin-left:auto;
}
.close {
  z-index: 10;
}

@media screen and (max-width: 767px) {
  .modal-lg {
    max-width: unset;
    &.modal-dialog {
      margin: unset;
    }
    .modal-header {
      padding-right: 21px;
      padding-left: 21px;
    }
    .modal-body {
      padding-right: 21px;
      padding-left: 21px;
      &.narrow {
        padding-right: 21px;
        padding-left: 21px;
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .modal-sm, .modal-md, .modal-xl {
    max-width: unset;
    &.modal-dialog {
      margin: unset;
    }
    .modal-header {
      padding-right: 21px;
      padding-left: 21px;
    }
    .modal-body {
      padding-right: 21px;
      padding-left: 21px;
    }
  }
}
</style>
